import apiClient from "../../.../../../../http-common";
import authHeader from "../../../../authentication/authservices/auth-header";

export const postInputOutputAudit = (saveObj) => {
    return apiClient.post(`/clinicalCareChart/saveInputOutputAudit`, saveObj);
};

//Listing API
export const InputOutputAuditListing = (admissionId) => {
    console.log("admissionIdadmissionIdadmissionId",admissionId);
    
    return apiClient.get(`/clinicalCareChart/getInputOutputAuditTrail/${admissionId}`);
};